<template>
    <div class="row-1">
        <div
            class="photo-comp"
            @click="$refs.avatarClick.click()">

            <div class="ico">
                <i aria-hidden="true"  class="fal fa-camera"/>
            </div>
            <!--carregamento upload de imagem-->

            <div v-if="carregandoImg" id="upload-img">
                <div class="icon-inicial">
                    <ui-load-indicator
                        bg-color="#e7e9f4"
                        color="#69D296"
                        :h="50"
                        :stroke="8"
                    />
                </div>
            </div>
            <div v-if="blocked" class="block">
                <div id="upload-img"/>
                <div class="lock">
                    <i aria-hidden="true"  class="fal fa-lock-alt"/>
                </div>
            </div>
            <img
                ref="avatarImg"
                :src="avatarComputed"
                alt="Avatar" />

            <input
                id="file"
                ref="avatarClick"
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                @change="avatarPreview" />

        </div>
        <div
            v-if="totalPoints != '' && !userId"
            class="group-points"
            @click="showPointsSidebar()">
            {{totalPoints.value}} pontos
        </div>

        <div class="name">
            {{ returnName(userData.name) }}
        </div>
        <div class="group"/>
        <div class="team" title="Equipe">
            <div v-if="userData.teans && userData.teans.length == 0" class="text-team text-primary">
                {{ userData.team }}
            </div>
            <div v-else-if="userData.teans && userData.teans.length < 2 && userData.teans.length > 0" class="text-team text-primary">
                {{userData.team}}
            </div>
            <div v-else>
                <ui-tooltip
                    :btn-title="userData.team"
                    :msg='userData.teans'
                />
            </div>
        </div>
        <div class="info">
            {{ typeGroup(userData.group) }}
            <span v-if="userData.creci">
                - CRECI {{ userData.creci }}
                <span v-if="userData.uf">-{{userData.uf}}</span>
            </span>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator, uiTooltip } from '@/components/ui'
import { storage                    } from '@/services/storage'
import { user                       } from '@/services/axios'
import { mapActions                 } from 'vuex'

export default {
    name: 'ui-user-profile',
    components: {
        uiLoadIndicator,
        uiTooltip
    },
    props:{
        imgAvatar:{
            type: String,
            default: ''
        },
        totalPoints:{
            type: [Object, String],
            default: () => {}
        },
        team:{
            type: [Object, String],
            default: () => {}
        },
        teams:{
            type: [Object, String],
            default: () => {}
        },
        userId: {
            type: [Object, String],
            default: () => {}
        },
        userData: {
            type: [Object, String],
            default: () => {}
        },
        blocked: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            getLocalStorage: '',
            carregandoImg: false,
        }
    },
    computed: {
        avatarComputed: {
            get() {
                return this.imgAvatar
            },
            set (value) {
                return value
            }
        }
    },
    created() {
        this.getLocalStorage = JSON.parse(storage.get('user_logged'))
    },
    methods: {
        ...mapActions('auth',['authExists']),
        showPointsSidebar() {
            this.$emit('showpoints')
        },
        typeGroup(group) {
            var groupUser = ''
            switch (group) {
                case 'admin':
                  groupUser = storage.get('label_admin') || 'Administrador'
                    break
                case 'broker':
                   groupUser = storage.get('label_broker') || 'Corretor'
                   break
                case 'manager':
                   groupUser = storage.get('label_manager') || 'Gerente'
                   break
                case 'supervisor':
                   groupUser = storage.get('label_supervisor') || 'Supervisor'
                   break
                case 'collaborator':
                   groupUser = storage.get('label_collaborator') ||'Colaborador'
                   break
                default:
                    groupUser = group
            }
            return groupUser
        },
        //retorna o nome do usuário com camelCase
        returnName(name) {
            if (name) {
                let setName = name.split(" ")
                let transformName = []
                let newName = null
                setName.forEach(element => {
                    if(element && element.length > 2) {
                        var nameUpperCase = element.toLowerCase()
                        transformName.push(nameUpperCase[0].toUpperCase() + nameUpperCase.substr(1))
                    }
                    else {
                        transformName.push(element)
                    }
                });
                newName = transformName.join(" ")
                return newName
            }
        },
        async avatarPreview(event) {
            const avatarInputFile = event.target.files[0]
            if (avatarInputFile.size <= 1500000) {
                this.carregandoImg = true
                let uploadImg
                /**
                 * TRANSFORMANDO IMAGEM EM BASE64 PARA MANDAR AOU LOCAL STORAGE
                 */
                var reader = new FileReader()
                var getLocalStorage = JSON.parse(storage.get('user_logged'))
                if (!this.userId) {
                    reader.addEventListener('load', () => {
                        getLocalStorage.photo = reader.result
                        storage.set('user_logged', JSON.stringify(getLocalStorage))
                    })
                } else {
                    reader.addEventListener('load', () => {
                        uploadImg = reader.result
                    })
                }
                reader.readAsDataURL(avatarInputFile)
                /**
                 * SALVANDO FOTO
                 */

                const fd = new FormData()
                fd.append('photo', avatarInputFile)
                fd.append('email', this.userData.email)
                fd.append('user_group', this.userData.group)
                await user
                    .create(this.userData.id, fd)
                    .then(async () => {
                        if(!this.userId) {
                            var newImagToStorage = JSON.parse(storage.get('user_logged'))
                            await setTimeout(() => {
                                this.$emit('imput', newImagToStorage.photo)
                                this.carregandoImg = false
                                /**
                                 * AO FINALIZAR A ATUALIZAÇÃO CHAMAR O METODO DE ATUALIZAR USUARIO
                                 */
                                this.authExists()
                            }, 500)
                        } else {
                            this.$emit('imput', uploadImg)
                            this.carregandoImg = false
                            this.authExists()
                        }
                    })
                    .catch((error) => {
                        console.error('Erro ao tentar salvar.')
                        console.error('error')
                        console.error(error)
                    })
            } else {
                alert(
                    'Este arquivo é superior a 1.5mb, favor, inserir uma imagem menor ou igua a 1.5mb'
                )
            }
        },
    }
}
</script>

<style lang='stylus' scoped>
    @import '../styles.styl'
</style>